module.exports = __webpack_public_path__ + "static/media/dashboardActive.36a5401a.svg";